import {
    ORDER_FORM_PROGRAMMATIC_SCROLL_ENABLED,
} from "./orderFormAccordionConstants.js"
import { focusElement } from "../utils/scrollFocusedElement.js"

/**
 * Focus the accordion Next button without browser scroll-on-focus, optionally
 * followed by a gentle delayed scroll to keep the focused control visible.
 * @param {{ current: HTMLButtonElement | null }} btnRef
 */
export function focusOrderFormNextButton(btnRef) {
    window.requestAnimationFrame(() => {
        focusElement(btnRef.current, { enabled: ORDER_FORM_PROGRAMMATIC_SCROLL_ENABLED, delay: true })
    })
}
